import Input from "components/materials/Form/InputElement";
import classes from "./classes.module.scss";
import I18n from "components/materials/I18n";
import ThemeSelector from "components/materials/ThemeSelector";
import { EProjectTheme } from "common/enums/ProjectTheme/ProjectTheme";
import Select from "components/materials/Form/SelectElement";
import { EProjectFormat } from "common/enums/ProjectFormat/ProjectFormat";
import { TextArea } from "components/materials/Form/TextAreaElement";
import ProjectConfigResponseResource from "common/resources/Project/Config/ProjectConfig/ProjectConfigResponseResource";
import { translateISO369 } from "utils/I18nText";
import { useProjectTitle } from "components/pages/ProfessionalSpace/contexts/ProjectTitle";
import { useCallback } from "react";

type IProps = {
	config: ProjectConfigResponseResource | null;
	selectedTheme: EProjectTheme | null;
	onSelect: (theme: EProjectTheme) => void;
	isProjectAnchored: boolean;
};

export default function ProjectInfoInputs(props: IProps) {
	const { title, setTitle } = useProjectTitle();

	const onTitleChange = useCallback(
		(e: React.ChangeEvent<HTMLInputElement>) => {
			setTitle(e.target.value);
		},
		[setTitle],
	);

	return (
		<div className={classes["root"]}>
			<Input
				name="title"
				defaultValue={title}
				disabled={props.isProjectAnchored}
				onChange={onTitleChange}
				label={I18n.asset.pages.professional_space.tabs.information.project_info.project_title}
				placeholder={I18n.asset.pages.professional_space.tabs.information.project_info.project_title_placeholder}
				required
			/>
			<Input
				name="subtitle"
				defaultValue={props.config?.subtitle ? translateISO369(props.config.subtitle) : null}
				label={I18n.asset.pages.professional_space.tabs.information.project_info.project_subtitle}
			/>
			<ThemeSelector onSelect={props.onSelect} selectedTheme={props.selectedTheme} />
			<Select
				className={classes["select"]}
				defaultValue={props.config?.project.format}
				name="format"
				label={I18n.asset.pages.professional_space.tabs.information.project_info.project_format}
				options={[
					{ label: I18n.asset.enums.EProjectFormats.long_metrage, value: EProjectFormat.long_metrage },
					{ label: I18n.asset.enums.EProjectFormats.court_metrage, value: EProjectFormat.court_metrage },
					{ label: I18n.asset.enums.EProjectFormats.serie, value: EProjectFormat.serie },
					{ label: I18n.asset.enums.EProjectFormats.documentaire, value: EProjectFormat.documentaire },
				]}
				required
			/>
			<Input
				name="developmentStage"
				defaultValue={props.config?.developmentStage ? translateISO369(props.config.developmentStage) : null}
				label={I18n.asset.pages.professional_space.tabs.information.project_info.production_stage}
			/>
			<Input
				name="projectNeeds"
				defaultValue={props.config?.projectNeeds ? translateISO369(props.config.projectNeeds) : null}
				label={I18n.asset.pages.professional_space.tabs.information.project_info.looking_for}
			/>
			<TextArea
				name="description"
				disabled={props.isProjectAnchored}
				defaultValue={props.config?.description ? translateISO369(props.config.description) : null}
				label={I18n.asset.pages.professional_space.tabs.information.project_info.project_pitch}
				placeholder={I18n.asset.pages.professional_space.tabs.information.project_info.project_pitch_placeholder}
				additionalInfo={I18n.asset.pages.professional_space.tabs.information.project_info.project_pitch_additional_info}
				required
			/>
		</div>
	);
}
